import { useParams } from 'react-router-dom';
import { useStaffDetail } from '@/entities/staff';
import { WidgetsStaffFormMain } from '@/widgets/staff-form';
import { extractErrorMessage } from '@/shared/api/errors';

export const PagesStaffEditMain = () => {
  const { id = '' } = useParams<{ id: string }>();
  const query = useStaffDetail(id);
  const errMsg = query.error ? extractErrorMessage(query.error) : undefined;
  return (
    <WidgetsStaffFormMain
      mode="edit"
      staff={query.data}
      loading={query.isLoading}
      notFound={!query.isLoading && !query.data && !query.error}
      loadError={errMsg}
      onRetry={() => void query.refetch()}
    />
  );
};
